import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const SuccessStories = () => {
  return <CommingSoon />;
};

export default SuccessStories;
